import { render, staticRenderFns } from "./BasicStatisticCard.vue?vue&type=template&id=6f2d55bd&scoped=true"
import script from "./BasicStatisticCard.vue?vue&type=script&lang=ts"
export * from "./BasicStatisticCard.vue?vue&type=script&lang=ts"
import style0 from "./BasicStatisticCard.vue?vue&type=style&index=0&id=6f2d55bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d55bd",
  null
  
)

export default component.exports